var map = {
	"./dan.png": "3a49",
	"./denmark-flag-round-small.png": "9ee8",
	"./eng.png": "2e72",
	"./fin.png": "01fd",
	"./finland-flag-round-small.png": "602a",
	"./nor.png": "21c5",
	"./norway-flag-round-small.png": "dfb9",
	"./swe.png": "f741",
	"./sweden-flag-round-small.png": "7096",
	"./united-kingdom-flag-round-small.png": "edc7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";